import styled from 'styled-components';

export const AboutWrapper = styled.div`
.text-align-justify{
    text-align: justify;
}
.entry-title {
    font-weight: 600;
    font-size: 1.9rem;
    text-align: center;
}
.youtube-link a{
    color: #647f19;
    font-size: larger;
}
.related-link{
    padding-bottom: 2vh;
}
`;
